<template>
	<div class="job-card">
		<div class="unread-posts" v-if="unreadPosts > 0">
			<span>{{ unreadPosts }}</span>
		</div>
		<!-- <div class="job-approve-icon-wrapper" v-if="job_approved">
			<mdb-icon icon="check" class="job-approve-icon" />
		</div>-->
		<div class="job-card-header">
			<div class="col-md-4 job-card-header-placed-date">Placed Date: {{ create_time_stamp }}</div>
			<div class="col-md-4 job-card-header-run-date">Run Date: {{ run_date }}</div>
			<div v-if="job.deadline" class="col-md-4 job-card-header-deadline">Deadline: {{ deadline }}</div>
		</div>
		<div class="job-card-body">
			<div class="col-9 job-card-body-title">
				<div class="col-12 job-card-body-title-content px-0">Job Title: {{ job.job_title }}</div>
				<div class="col-12 px-0">
					<div
						class="col-6 job-card-body-title-content px-0"
						v-if="job.booking_number"
					>Booking Number: {{ job.booking_number }}</div>
					<div
						class="col-6 job-card-body-title-content px-0"
						v-if="job.publication_name"
					>Publication Name: {{ job.publication_name }}</div>
				</div>
			</div>
			<!-- <div class="col-3 job-card-body-title">
				<p>{{ job.booking_number }}</p>
			</div>
			<div class="col-3 job-card-body-title">
				<p>{{ job.publication_name }}</p>
			</div>
			<div class="col-3 job-card-body-title">
				<p>{{ job.job_title }}</p>
			</div>-->
			<div class="col-3 job-card-body-button">
				<mdb-btn class="btn-color-primary" @click.native.prevent="toggleCollapse">More Info</mdb-btn>
			</div>
		</div>
		<div
			class="job-card-collapse"
			:class="{ 'job-card-collapse-open': !isCollapseActive }"
			ref="collapse"
		>
			<div class="job-card-collapse-content">
				<div class="job-card-collapse-content-text">
					<div class="col-6">Job Id:</div>
					<div class="col-6">{{ job.job_id }}</div>
				</div>
				<hr>
				<div class="job-card-collapse-content-text">
					<div class="col-6">Publication Type:</div>
					<div class="col-6">{{ job.publication_type }}</div>
				</div>
				<hr>
				<div class="job-card-collapse-content-text">
					<div class="col-6">Colour Mode:</div>
					<div class="col-6">{{ job.colour_mode }}</div>
				</div>
				<hr>
				<div class="job-card-collapse-content-text">
					<div class="col-6">Status:</div>
					<div class="col-6">{{ job.job_status }}</div>
				</div>
				<hr v-if="job.client_name">
				<div class="job-card-collapse-content-text" v-if="job.client_name">
					<div class="col-6">Client Name:</div>
					<div class="col-6">{{ job.client_name }}</div>
				</div>
				<hr v-if="job.staff_name">
				<div class="job-card-collapse-content-text" v-if="job.staff_name">
					<div class="col-6">Staff Name:</div>
					<div class="col-6">{{ job.staff_name }}</div>
				</div>
			</div>
			<div class="job-card-collapse-button" @click="getJob" v-if="isGetJob">Take ownership</div>
			<router-link :to="{ name: 'job-details', params: { job_id: job.job_id } }">
				<div class="job-card-collapse-button">View job</div>
			</router-link>
		</div>
	</div>
</template>

<script>
import { mdbBtn, mdbIcon } from 'mdbvue'
import moment from 'moment'

export default {
	name: 'JobCard',
	components: {
		mdbBtn,
		mdbIcon
	},
	data() {
		return {
			isCollapseActive: true,
			height: 0,
			create_time_stamp: moment(this.job.create_time_stamp).format(
				'D MMMM YYYY'
			),
			run_date:
				this.job.run_date === 'none'
					? 'none'
					: moment(this.job.run_date).format('D MMMM YYYY'),
			deadline:
				this.job.deadline === 'none'
					? 'none'
					: moment(this.job.deadline).format('D MMMM YYYY')
		}
	},
	computed: {
		isGetJob() {
			const jobStaffEmail = this.job.staff_email
			const user = JSON.parse(sessionStorage.getItem('user'))
			const { email, profile } = user
			let isMyJob
			if (profile === 'Staff') {
				isMyJob = email === jobStaffEmail ? true : false
			} else {
				isMyJob = false
			}
			const isStaff =
				JSON.parse(sessionStorage.getItem('user')).profile === 'Staff'
					? true
					: false

			const job_status = this.job.job_status
			const isCompleted = job_status === 'completed' ? true : false
			return !isMyJob && isStaff && !isCompleted
		},
		unreadPosts() {
			const user = JSON.parse(sessionStorage.getItem('user'))
			const { profile } = user
			if (profile === 'Staff') {
				return this.job.unread_client_posts
			} else {
				return this.job.unread_staff_posts
			}
		},
		publication_name() {
			const publication_name = this.job.publication_name
				? this.job.publication_name
				: ''
			return publication_name
		}
	},
	methods: {
		toggleCollapse() {
			if (this.isCollapseActive) {
				this.$refs.collapse.style.height =
					this.$refs.collapse.scrollHeight + 'px'
			} else {
				this.$refs.collapse.style.height = 0
			}
			this.isCollapseActive = !this.isCollapseActive
		},
		async getJob() {
			const user = JSON.parse(sessionStorage.getItem('user'))
			const staff_email = user.email
			const staff_name = user.name
			const job_status = 'processing'
			await this.$store.dispatch('job/acceptJob', {
				job_id: this.job.job_id,
				staff_name,
				staff_email,
				job_status
			})
		}
	},
	props: {
		job: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/jobCard.scss';
</style>
